import { Alignment, CrossAxisAlignment, MainAxisAlignment } from "@judo/model-api";

/**
 * Map MainAxisAlignment enum to CSS justify-content value.
 */
export function mapMainAxisAlignment(alignment: MainAxisAlignment | undefined): string {
	switch (alignment) {
		case MainAxisAlignment.START:
			return "flex-start";
		case MainAxisAlignment.END:
			return "flex-end";
		case MainAxisAlignment.CENTER:
			return "center";
		case MainAxisAlignment.SPACEBETWEEN:
			return "space-between";
		case MainAxisAlignment.SPACEAROUND:
			return "space-around";
		case MainAxisAlignment.SPACEEVENLY:
			return "space-evenly";
		default:
			return "flex-start";
	}
}

/**
 * Map CrossAxisAlignment enum to CSS align-items value.
 */
export function mapCrossAxisAlignment(alignment: CrossAxisAlignment | undefined): string {
	switch (alignment) {
		case CrossAxisAlignment.START:
			return "flex-start";
		case CrossAxisAlignment.END:
			return "flex-end";
		case CrossAxisAlignment.CENTER:
			return "center";
		case CrossAxisAlignment.STRETCH:
			return "stretch";
		case CrossAxisAlignment.BASELINE:
			return "baseline";
		default:
			return "stretch";
	}
}

/**
 * Map Alignment enum to CSS position properties.
 */
export function mapAlignment(alignment: Alignment | undefined): {
	justifyContent: string;
	alignItems: string;
} {
	switch (alignment) {
		case Alignment.TOP_LEFT:
			return { justifyContent: "flex-start", alignItems: "flex-start" };
		case Alignment.TOP_CENTER:
			return { justifyContent: "center", alignItems: "flex-start" };
		case Alignment.TOP_RIGHT:
			return { justifyContent: "flex-end", alignItems: "flex-start" };
		case Alignment.CENTER_LEFT:
			return { justifyContent: "flex-start", alignItems: "center" };
		case Alignment.CENTER:
			return { justifyContent: "center", alignItems: "center" };
		case Alignment.CENTER_RIGHT:
			return { justifyContent: "flex-end", alignItems: "center" };
		case Alignment.BOTTOM_LEFT:
			return { justifyContent: "flex-start", alignItems: "flex-end" };
		case Alignment.BOTTOM_CENTER:
			return { justifyContent: "center", alignItems: "flex-end" };
		case Alignment.BOTTOM_RIGHT:
			return { justifyContent: "flex-end", alignItems: "flex-end" };
		default:
			return { justifyContent: "flex-start", alignItems: "flex-start" };
	}
}
